/**
 * @desc Find permission requests for the current user
 */

import * as defs from '../../baseClass';
import * as Hooks from '../../../hooks';

import { getUrl } from '../../../url.utils';

import * as SWR from 'swr';

import { PontCore } from '../../../pontCore';

export class Params {}

export const method = 'GET';

export function mutate(params = {}, newValue = undefined, shouldRevalidate = true) {
  return SWR.mutate(
    Hooks.getUrlKey('/v1/permission/request/me', params, 'GET'),
    newValue,
    shouldRevalidate,
  );
}

export function useRequest(params = {}, swrOptions = {}) {
  return Hooks.useRequest('/v1/permission/request/me', params, swrOptions);
}

export function request(params = {}, option = {}) {
  const { url, body } = getUrl('/v1/permission/request/me', params, 'GET', option);
  return PontCore.fetch(url, {
    body,
    ...option,
    method: 'GET',
  });
}
